import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-posts',
    templateUrl: './posts.component.html',
    styleUrls: ['./posts.component.scss'],
    standalone: false
})
export class PostsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
